import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MarsAndBeyondPage } from "./mars-and-beyond.page";

const routes: Routes = [
  {
    path: "**",
    component: MarsAndBeyondPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MarsAndBeyondPageRoutingModule { }
